/* eslint-disable react/prop-types */

import React from "react";
import { Popover, List, makeStyles } from "@material-ui/core";
import ListItemComponent from "./ListItemComponent";

const useStyles = makeStyles(() => ({
  popoverRoot: {
    marginTop: "-5px",
  },
  listRoot: {
    padding: "0px",
  },
}));

const PopoverComponent = ({
  anchorEl,
  handleClose,
  options,
  handleItemClick,
}) => {
  const classes = useStyles();
  return (
    <Popover
      className={classes.popoverRoot}
      open={Boolean(anchorEl)}
      onClose={handleClose}
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      transformOrigin={{ vertical: "top", horizontal: "left" }}
    >
      <List className={classes.listRoot}>
        {options.map((option) => (
          <ListItemComponent
            key={option.key}
            option={option}
            onClick={handleItemClick}
          />
        ))}
      </List>
    </Popover>
  );
};

export default PopoverComponent;
